'use strict';

angular.module('app')
    .service('Liveaboard', function ($location, $injector, $window, utils, SeoService) {
        function Liveaboard(model) {
            this.info = model;
            this.pageURL = $location.path();
            this._data = {};

            if (this.info.itinerariesLength) {
                var obj = [];
                _.each(this.info.itinerariesLength, function(val){
                    obj.push({
                        id: val,
                        title: val + ' night' + (val === 1 ? "" : "s")
                    });
                });

                this.info.itinerariesLength = obj;
            }

            this.init();
        }

        Liveaboard.prototype = {
            init: function () {
                var _this = this,
                    title = _this.info.title + ' | Liveaboard | PADI Travel',
                    description = 'Explore the liveaboard ' + _this.info.title + ' in ' + _this.info.country + '. ✓Reviews & ratings ✓Photos & itineraries ✓Schedules & pricing. Book your scuba dive safari online!';

                _this.seo = {
                    title: _this.info.metaTitle || title,
                    description: _this.info.metaDescription || description,
                    image: _this.info.backgrounds ? _this.info.backgrounds.DOSliderDesktop : null,
                    kind: 'product'
                };

                SeoService.generateMetaTags(_this.seo.title, _this.seo.description, _this.seo.image, _this.seo.kind);

                if (_this.info.productsCount > 0) {
                    _this.haveProducts = true;
                }
            },
            setLiveaboardAsViewed: function () {
                var recently = $injector.get('RecentlyViewed'),
                    route = $injector.get('$routeParams');

                if (!this.info.isRecentlyViewed) {
                    recently.add({
                        item_type: 'Shop',
                        item_slug: route.slug
                    });
                }

                return this;
            },
            setMainGTM: function () {
                var GTM = $injector.get('GTM');

                GTM.variables({
                    operator_id: this.info.id,
                    operator_name: this.info.title,
                    operator_type: this.info.kindVerbose,
                    operator_area: this.info.area,
                    operator_country: this.info.country,
                    operator_rating_average: this.info.rating
                });

                return this;
            },
            getPhotos: function (callback) {
                var photos = $injector.get('DiveOperator'),
                    obj = {},
                    _this = this;

                if (!_.isEmpty(_this.info.backgrounds)) {
                    _this.info.background = {
                        title: 'Main photo',
                        id: 880055355, // randomed number
                        thumbnails: {
                            DOSliderDesktop: _this.info.backgrounds.DOSliderDesktop,
                            DOSliderTabletLand: _this.info.backgrounds.DOSliderTabletLand,
                            DOSliderTabletPort: _this.info.backgrounds.DOSliderTabletPort,
                            DOSliderMobileLand: _this.info.backgrounds.DOSliderMobileLand,
                            DOSliderMobilePort: _this.info.backgrounds.DOSliderMobilePort
                        }
                    };
                }

                photos.liveaboardPhotos().then(function (data) {
                    obj.slidersImages = data.groupedPhotos;
                    obj.allPhotos = data.allPhotos;

                    var screenWidth = angular.element($window)[0].innerWidth,
                        goodQuality = screenWidth - (screenWidth * 0.35);

                    _.each(obj.slidersImages, function (val) {
                        val.badImages = [];
                        val.goodImages = [];

                        _.each(val, function (v) {
                            if (v.width < goodQuality) {
                                val.badImages.push(v);
                            } else {
                                val.goodImages.push(v);
                            }
                        });
                    });
                    // If shop have a background image -> then we need to add this image on first position of photos array;
                    if (_this.info.background) {
                        obj.allPhotos.unshift(_this.info.background);
                    }


                    // If we don't have any photos - we need to show message for user. Because users need to know, why this shit is happen;
                    if (data.allPhotos.length === 0) {
                        obj.noPhotos = true;
                    }

                    if (callback && _.isFunction(callback)) {
                        callback(obj);
                    }
                });

                return _this;
            },
            getProducts: function (date, disableChange, filter, callback, url, revert) {
                var _this = this,
                    DiveOperator = $injector.get('DiveOperator'),
                    utils = $injector.get('utils'),
                    GTM = $injector.get('GTM'),
                    $timeout = $injector.get('$timeout');

                if (!date) {
                    date = _this.filterDate || {};
                }
                _this.priceLoading = true;

                var analyticProducts = {
                    detail: {
                        product: []
                    }
                };

                $timeout(function () {
                    if (window.fbq) {
                        fbq('track', 'ViewContent', {
                            content_ids: [_this.info.id],
                            content_type: 'product',
                            value: _this.info.minimalPrice,
                            currency: _this.info.currency
                        });
                    }
                }, 4000);

                DiveOperator.getTrips(date, filter, url, revert).then(function (data) {
                    if (data !== false) {
                        _this.allProducts = data.all;
                        _this.products = _.each(data.trips, function (trip) {
                            trip.title = trip.title.trim();
                            if (trip.itinerary) {
                                trip.itinerary.title = trip.itinerary.title.trim();
                            }

                            analyticProducts.detail.product.push({
                                name: trip.title,
                                id: trip.id,
                                price: trip.price,
                                brand: trip.vendor,
                                category: _this.info.kindVerbose
                            });
                        });

                        _this.groupedProducts = {};

                        if (_this.filterDate && (_this.filterDate.month === 'Show all' || _this.filterDate.month === 'Show available')) {
                            _.each(data.trips, function (data) {
                                var month = moment(data.startDate).month(),
                                    year = moment(data.startDate).year();

                                if (!_this.groupedProducts[year + '_' + month]) {
                                    _this.groupedProducts[year + '_' + month] = [];
                                }

                                _this.groupedProducts[year + '_' + month].push(data);
                            });
                        }
                        _this.priceLoading = false;
                    }
                });
            },
            setDate: function () {
                var localStorageService = $injector.get('diviacLocalStorage'),
                    sessionDate = localStorageService.get('date');

                this.date = sessionDate || null;
                this.sessionStorage = localStorageService;

                if (sessionDate && sessionDate.length) {
                    this._data.from = sessionDate[0] ? moment(sessionDate[0]).format('YYYY-MM-DD') : null;
                    this._data.to = sessionDate[1] ? moment(sessionDate[1]).format('YYYY-MM-DD') : null;

                    this._data.fromFullDate = sessionDate[0];
                    this._data.toFullDate = sessionDate[1];

                    this._data.sidebarFilterDate = {
                        month: sessionDate[0] ? moment(sessionDate[0]).format("MMMM") : null,
                        startDate: sessionDate[0] ? moment(sessionDate[0]).format('YYYY-MM-DD') : null,
                        endDate: sessionDate[1] ? moment(sessionDate[1]).format('YYYY-MM-DD') : null,
                        year: sessionDate[0] ? (new Date(sessionDate[0])).getFullYear() : null
                    };

                    this._data.filterDate = this._data.sidebarFilterDate;
                } else {
                    this._data.showDetail = true;
                }

                return this._data;
            },
            setAvailableDates: function (callback) {
                var monthCount = moment().month(),
                    obj = {
                        dates: [{
                            month: 'Show available'
                        }, {
                            month: 'Show all'
                        }]
                    };

                if (!this.info) {
                    return {};
                }

                while (monthCount < this.info.monthsAmountWithProducts + moment().month() + 1) {
                    obj.dates.push({
                        month: moment().month(monthCount).locale('en').format("MMMM"),
                        startDate: moment().month(monthCount).subtract(0, 'months').startOf('month').format('YYYY-MM-DD'),
                        endDate: moment().month(monthCount).subtract(0, 'months').endOf('month').format('YYYY-MM-DD'),
                        year: moment().month(monthCount).format('YYYY')
                    });
                    monthCount++;
                }

                if (callback && _.isFunction(callback)) {
                    callback(obj.dates);
                }

                return this;
            }
        }

        return Liveaboard;
    });
